export default function CopyRightSection() {
  return (
    <div >
      <p className="text-center mt-2 py-4 text-xs w-full border-solid border-t-[1px] border-t-light-200 ">
        از اینکه مطالب رایان کامرس را با ذکر منبع منتشر می‌کنید، از شما سپاسگزاریم. کلیهٔ حقوق این وب‌سایت محفوظ و متعلق به شرکت «سپهر رایات ستاره شرق» است.
      </p>
    </div>
  )
}